export const WEATHER_ACTION = "WEATHER_ACTION"

// user section
export const ADD_USER = "ADD_USER"
export const FETCH_USER = "FETCH_USER"

//  code section
export const FETCH_ROOMS = "FETCH_ROOMS"
export const CREATE_ROOM = "CREATE_ROOM"
export const UPDATE_ROOMS_STATE = "UPDATE_ROOMS_STATE"